
export class ChoiceEnum {

    value: string;
    label: string;

    constructor() {
        this.value = "";
        this.label = "";
    }

}

